export const getHighlightedSuggestionText = (
  suggestion: string,
  inputValue: string,
) => {
  if (!inputValue) return suggestion;
  const cleanedInputValue = inputValue.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const highlightingRegex = new RegExp(`(${cleanedInputValue})`, "gi");
  const splitSuggestionString = suggestion.split(highlightingRegex);

  return splitSuggestionString.map((suggestionSegment, index) => {
    if (suggestionSegment.toLowerCase() === inputValue.toLowerCase()) {
      return <span key={index}>{suggestionSegment}</span>;
    } else {
      return <strong key={index}>{suggestionSegment}</strong>;
    }
  });
};
